import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import AppCustomLink from '../components/Common/AppCustomLink';
import AppSideScroll from '../components/Common/AppSideScroll';
// import Link from 'next/link';

import { NextSeo } from 'next-seo';
import { cdnApi, sortAlphabetically, sortPubDate, podcastTypes, initialGenreCount, firestoreApi } from '../lib/utils';
import { FETCH_SUBSCRIBED_PODCASTS_ERROR } from '../actions/types';

import memoizeOne from 'memoize-one';
// import { getRequiredPodcasts } from '../reducers';
import { fetchLatestSubscribedEpisodes, fetchSpecificBlogList, fetchTopChartsMagazines, fetchTopChartsPodcasts } from '../actions';
import { colors, spacing, mainLayoutColor, leftSideBar } from '../lib/theme';
import Loading from '../components/Common/Loading';
import RecentPodcasts from '../components/Common/RecentPodcasts';
import EmptyState from '../components/Common/EmptyState';
import MultiRowEpisode from '../components/Common/MultiRowEpisode';
import HomePodcasts from '../components/Common/HomePodcasts';
import PodcastHeader from '../components/Podcast/PodcastHeader';
import Podcast from '../components/Podcast/Podcast';
import PodcastEpisode from '../components/Podcast/PodcastEpisode';
import EpisodeSkeleton from '../components/Podcast/EpisodeSkeleton';
// import { Alert } from 'antd';
import DiscoverMore from '../components/Common/DiscoverMore';
import ImportOpml from '../components/Common/ImportOpml';
import TrendingInterests from '../components/Common/TrendingInterests';
import FeaturedLists from '../components/Common/FeaturedLists';
import BlogLists from '../components/Common/BlogLists';
import MoreLikeThis from '../components/Common/MoreLikeThis';
import AppAlertDiv from '../components/Common/AppAlertDiv';
import { SyncOutlined } from '@ant-design/icons';
import YourPodcastOptions from '../components/Podcast/YourPodcastOptions';
import SubscribedPodcastsGrid from '../components/Podcast/SubscribedPodcastsGrid';
import { setRelevantPodcastGenres } from '../lib/fileUtils';
import { TOP_10 } from '../lib/strings';
import RelevantPodcasts from '../components/Common/relevantPodcasts';
import BookOfDay from '../components/Common/BookOfDay';
import ForYouHome from '../components/Common/ForYouHome';

const featuredLists = [
  { id: 'Business', name: 'Business Magazines' },
  { id: 'Mind', name: 'Mind & Health Magazines' },
  { id: 'Tech', name: 'Tech Magazines' },
  { id: 'Science', name: 'Science Magazines' },
];
class NewsAndMagazines extends React.Component {
  static async getInitialProps(context) {
    let fromPageLoad = true;
    if (process.browser) {
      fromPageLoad = false;
    }
    return { fromPageLoad };
  }
  constructor(props) {
    super(props);
    this.state = { initialLoad: props.fromPageLoad, removeLoader: false, featuredPodacastLists: {} };
  }

  async componentDidMount() {
    this._ismounted = true;
    const { userDetails, subscribedPodcasts } = this.props;
    const { loadingUserDetails, loadingPodcasts } = this.props.loadingState;

    const promises = [fetchTopChartsPodcasts('cache-news', 1)];
    for (const list of featuredLists) {
      promises.push(fetchTopChartsMagazines(list.id, 1));
    }
    const results = await Promise.all(promises);
    console.dir(results);
    const featuredPodacastLists = {};
    featuredPodacastLists['Quick News'] = results[0];
    for (let ind = 0; ind < results.length - 1; ind++) {
      featuredPodacastLists[featuredLists[ind]['name']] = results[ind + 1];
    }
    console.dir(featuredPodacastLists);
    this.setState({ featuredPodacastLists });
  }

  componentDidUpdate(prevProps) {
    const { userDetails, subscribedPodcasts } = this.props;
    const { loadingUserDetails } = this.props.loadingState;
    // const { loadingUserDetails, loadingPodcasts } = this.props.loadingState;

  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  // setPageData(subscribedPodcasts) {
  //   this.props.fetchLatestSubscribedEpisodes(Object.values(subscribedPodcasts));
  // }

  // refreshLatestEpisodes = () => {
  //   const { subscribedPodcasts } = this.props;
  //   this.props.fetchLatestSubscribedEpisodes(Object.values(subscribedPodcasts), true);
  // }

  // sortLatestEpisodes = memoizeOne((latestEpisodes) => {
  //   return latestEpisodes.sort(sortPubDate);
  // })

  render() {
    const { userDetails, episodes, subscribedPodcasts, settingsState } = this.props;
    const { removeLoader, initialLoad, featuredPodacastLists } = this.state;
    const { loadingUserDetails, loadingPodcasts, loadingLatestEpisodes, loadingRecentPlayed } = this.props.loadingState;
    // const { subscribedPodcasts } = this.props.podcastState;
    // const subscribedPodcasts = podcastState;
    const latestEpisodes = Object.values(episodes);
    const { FETCH_SUBSCRIBED_PODCASTS_ERROR } = this.props.fetchError;
    const fetchError = FETCH_SUBSCRIBED_PODCASTS_ERROR;

    const subscribedPodcastsList = Object.values(subscribedPodcasts);
    console.dir(featuredPodacastLists);
    return (
      <div className='list'>
        <NextSeo
          title='Accelerated News And Magazines'
          description='News And Magazines'
          canonical='https://tedapp.ai/news-and-magazines'
        // openGraph={{
        //   type: 'website',
        //   locale: 'en_IE',
        //   url: 'https://tedapp.ai/home',
        //   site_name: 'Accelerated',
        // }}
        // twitter:{
        //     handle: '@handle',
        //     site: '@site',
        //     cardType: 'summary_large_image',
        // }
        />
        {/* <Nav /> */}
        {/* <Tabs defaultActiveKey="Subscribed">
          <Tabs.TabPane tab="Subscribed Podcasts" key="Subscribed"> */}
        <div style={{ height: '32px' }}></div>
        {Object.keys(featuredPodacastLists).map((podListKey, ind) => (
          <div key={ind}>
            <AppSideScroll title={podListKey}>
              {
                featuredPodacastLists[podListKey].map((podcast, index) =>
                  <div key={index} style={{ marginRight: `${spacing('lg')}` }}>
                    <Podcast className='cards' parentAd={podListKey} showArtistName={true}
                      podcast={podcast} showSubscribe={false} size='lg' />
                  </div>
                )
              }
            </AppSideScroll>
            {/* <div style={{ height: '16px' }}></div> */}
          </div>
        ))}
        {/* <HomePodcasts /> */}
        {/* <DiscoverMore /> */}
        < style jsx>
          {`
            .main-loader {
                background-color: ${settingsState.mainLayoutColor};
                position: absolute;
                width: calc(100vw - ${leftSideBar} - 90px); // 70%;
                height: 100%;
                z-index: 10;
                // padding-right: 5%;
                transition: opacity 0.3s;
                -webkit-transition: opacity 0.3s;
                opacity: 1;
            }
            .main-loader.remove {
                opacity: 0;
            }
            .title {
              margin-bottom: ${spacing('sm')};
            }
            .cards {
              float: left;
            }
            .flex {
              display: flex;
              flex-wrap: wrap;
              // justify-content: space-between;
            }
            .empty-state {
              text-align: center;
              height: 30vh;
              background-size: 120% 98%;
              background-position: center top;
              background-repeat: no-repeat;
            }
            :global(.search-btn){
              color: ${colors.third} !important;
              // text-decoration: underline;
            }
            :global(.ant-tabs-tab-active){
              color: ${colors.primary} !important;
            }
          `}
        </style>
      </div >
    )
  }
}

NewsAndMagazines.propTypes = {
  loadingState: PropTypes.object,
  subscribedPodcasts: PropTypes.object,
  // loadingUserDetails: PropTypes.bool,
  fetchError: PropTypes.object,
  userDetails: PropTypes.object,
  episodes: PropTypes.object,
  fetchLatestSubscribedEpisodes: PropTypes.func,
  recentPlayedEpisodes: PropTypes.object,
  settingsState: PropTypes.object,
  fromPageLoad: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    subscribedPodcasts: state.podcastState,
    episodes: state.latestEpisodes,
    loadingState: state.loadingState,
    fetchError: state.errorsState,
    recentPlayedEpisodes: state.recentPlayedEpisodes,
    settingsState: state.settingsState,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLatestSubscribedEpisodes: bindActionCreators(fetchLatestSubscribedEpisodes, dispatch),
  }
};

// export default withRedux(initStore, null, null)(Home);
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Home);

export default connect(mapStateToProps, mapDispatchToProps)(NewsAndMagazines);